export default __webpack_public_path__ + "static/barlow-v4-latin-300-f8ef1b613012ae7d27acf0c0fa32196c.woff2";